import React, { useEffect, useRef } from "react";
import FavoritesCarousel from "./FavoritesCarousel";

import favoritesBarre from "../../assets/online/favorites-barre.png";
import favoritesBooty from "../../assets/online/favorites-booty.png";
import favoritesChest from "../../assets/online/favorites-chest.png";
import favoritesPilates from "../../assets/online/favorites-pilates.png";
import favoritesPower from "../../assets/online/favorites-power.png";
import favoritesSpicyBarre from "../../assets/online/favorites-spicy-barre.png";
import favoritesSpicy from "../../assets/online/favorites-spicy.png";
import favoritesStrong from "../../assets/online/favorites-strong.png";
import favoritesSweat from "../../assets/online/favorites-sweat.png";
import favoritesTonedLegs from "../../assets/online/favorites-toned-legs.png";
import useFreeTrial from "../../hooks/useFreeTrial";

export default function LandingOnlineFavorites() {
  const { handleFreeTrial } = useFreeTrial();

  const containerRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        }
      });
    };

    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions,
    );

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  const slides = [
    favoritesBarre,
    favoritesBooty,
    favoritesChest,
    favoritesPilates,
    favoritesPower,
    favoritesSpicyBarre,
    favoritesSpicy,
    favoritesStrong,
    favoritesSweat,
    favoritesTonedLegs,
  ];

  return (
    <div
      id="favoritas"
      className="online-favorites position-relative bg-gradient-landing--plum"
    >
      <div className="opacity-0" ref={containerRef}>
        <h2 className="online-title favorites__title">
          Organiza tus clases y guarda tus favoritas{" "}
        </h2>
        <p className="favorites__des text-center" style={{ maxWidth: "1200px" }}>
          Marca tus clases favoritas con un corazón y tenlas siempre a la mano
          en un solo apartado. También puedes identificar las clases que ya
          hiciste para organizar mejor tu experiencia dentro de la plataforma y
          regresar fácilmente a las rutinas que más te gustaron.
        </p>
      </div>
      <FavoritesCarousel
        options={{ loop: true, duration: 30, align: "start" }}
        slides={slides}
      />

      <button
        onClick={handleFreeTrial}
        type="button"
        className="btn btn-primary favorites__btn"
      >
        Pruébalo 7 días gratis
      </button>
    </div>
  );
}
